'use client';

import clsx from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type TabType = {
  title: ReactNode;
  value: string;
};

const TabsFunction = ({ className, children }: { className?: string; children: ReactNode }) => {
  return (
    <div className={clsx('rounded-lg border border-neutral-900 p-1 flex justify-stretch w-full', className)}>
      {children}
    </div>
  );
};

export interface TabItemFunctionProps {
  tab: TabType;
  active: boolean;
  className?: string;
  onClick: (value: string) => void;
}

const TabItemFunction = ({ tab, active, className, onClick }: TabItemFunctionProps) => {
  return (
    <div
      role="button"
      onClick={() => onClick(tab.value)}
      className={twMerge(
        'flex-1 border border-transparent text-center rounded uppercase py-2 px-2 md:px-5 shrink-0 text-xs font-medium h-full text-neutral-100',
        active && 'bg-primary/20 border-primary shadow-lg shadow-primary/20 text-primary',
        className
      )}
    >
      {tab.title}
    </div>
  );
};

export const Tabs = Object.assign(TabsFunction, { Item: TabItemFunction });
